import { CONTINGENCY } from '../constants'

export function isRTBContingency(contingency) {
  return Object.values(CONTINGENCY).includes(contingency.action)
}

/**
 * Gets contingencies of a given funding option
 */
export function extractRTBContingency(fundingOption = {}) {
  const { contingencies } = fundingOption
  const foundContingency = contingencies && contingencies.find(isRTBContingency)
  return foundContingency || {}
}

export function hasRTBContingency(fundingOption = {}) {
  return !!extractRTBContingency(fundingOption).action
}
